import React from 'react'

import { css } from 'design'
import { Stack } from 'primitives/containers'
import { cn } from 'util/cn'

import { useHandleMetadata } from '../../../hooks/use_handle_metadata'
import { TimelineType } from '../../../types/models'
import Chat from './chat'

interface ReplyChatReferenceProps {
  timeline: TimelineType
}

const replyTimelineContainerStyles = css({
  flexGrow: 1,
  padding: '$1 $3 $3',
  borderLeft: '2px solid $grey200',
  borderRadius: '$1',
  backgroundColor: '$grey50',
  color: '$grey600',
  marginBottom: '$2',

  '.timeline': {
    padding: 0,
    pointerEvents: 'none',

    a: {
      pointerEvents: 'all',
    },
  },
  '> * + *': {
    marginTop: '$2',
  },
})

const replyMetadataStyles = css({
  fontSize: '$2',
  color: '$grey700',
})

export const ReplyChatReference = ({
  timeline,
  className,
  ...props
}: ReplyChatReferenceProps &
  React.HTMLAttributes<HTMLDivElement> &
  React.ComponentProps<typeof Stack>) => {
  const { handle } = timeline
  const { name } = useHandleMetadata(handle || undefined)
  return (
    <div className={cn(replyTimelineContainerStyles(), className)} {...props}>
      {name && (
        <Stack gap="1" direction="row" className={replyMetadataStyles()}>
          <span>Replying to</span>
          <b>{name}</b>
        </Stack>
      )}
      <Chat
        timeline={timeline}
        className={'reply-timeline'}
        withTimelineWrapper={false}
        withActionsBar={false}
        isAReplyTimeline={true}
        withTimelineInfo={false}
        withTopicSubject={false}
        withLink={false}
        showReply={false}
        threadedFrom={false}
      />
    </div>
  )
}
